<template>
  <div class="row">
    <div class="col-md-12">
      <div class="customer-pick-time">
        <FullCalendar ref="calendar" class="calendar" :options="calendarOptions"/>
      </div>
    </div>
    <div class="loading-wrapper" :class="{'loading-show': isLoading}">
      <div class="loading-spinner"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'Calendar',
  components: {
    FullCalendar,
    Breadcrumbs,
  },
  props: {
    currentCustomer: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isLoading: false,
      currentEvents: []
    };
  },
  computed: {
    ...mapGetters('permalink', ['permalinkData', 'selectedTimeprice', 'selectedTimepriceOptions', 'selectedTherapist']),

    calendarOptions() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        titleFormat: {year: 'numeric', month: 'short'},
        dayHeaderContent: (args) => {
          const day = args.date.getDate();
          const weekday = args.date.toLocaleDateString('ja-JP', { weekday: 'short' });
          return `${day} (${weekday})`;
        },
        selectable: true,
        contentHeight: 'auto',
        datesAboveResources: true,
        selectOverlap: false,
        allDaySlot: false,
        locale: 'ja',
        timeZone: 'Asia/Tokyo',
        initialView: 'timeGridWeek',
        firstDay: moment().format('e'),
        height: 'auto',
        editable: true,
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
        },
        slotLabelInterval: this.permalinkData?.slot_duration,
        slotDuration: this.permalinkData?.slot_duration,
        slotMinTime: this.permalinkData?.min_time_routine,
        slotMaxTime: this.permalinkData?.max_time_routine,
        events: (info, successCallback, failureCallback) => {
          const start = moment(info.start);
          const end = moment(info.end);
          const promises = [];
          this.handleLoading(true);
          for (let date = start; date.isBefore(end); date.add(1, 'days')) {
            const formattedDate = date.format("YYYY-MM-DD");
            const url = Routes.api_v1_get_customer_bookings_path({
              permalink: this.$route.params.permalink,
              format: 'json'
            });
            const params = {
              therapist_id: this.selectedTherapist?.id || '',
              timeprice_id: this.selectedTimeprice?.id,
              timeprices_option_ids: this.selectedTimepriceOptions.map(option => option.id).join(','),
              date: formattedDate
            };
            axios.get(url, { params })
              .then(response => {
                const events = response.data;
                promises.push(...events);
                this.$refs.calendar.getApi().addEventSource(events);
                this.handleLoading(false);
                successCallback(promises);
              })
              .catch(error => {
                failureCallback(error);
              });
          }
        },
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        loading: this.handleLoading(true),
      };
    },
  },
  methods: {
    ...mapActions('permalink', ['addEvent']),

    loadEvents() {
      this.$refs.calendar.getApi().refetchEvents();
    },

    handleDateSelect(selectInfo) {
    },

    handleEventClick(clickInfo) {
      const event = clickInfo.event;
      if (event.classNames.includes('in-working-time') && event.classNames.includes('scroll-top')) {
        this.addEvent(clickInfo.event);
        const startDate = event.start;
        const endDate = event.end;
        this.$emit('eventSelected', {startDate, endDate});
        this.$emit('showCustomerInfo');
      }
    },

    handleEvents(events) {
      this.currentEvents = events;
    },

    handleLoading(isLoading) {
      this.isLoading = isLoading;
    },

    goBack() {
      this.$emit('goBack');
    }
  }
}
</script>

<style lang="scss">
.calendar {
  width: 100%;
  display: inline-block;

  .fc-col-header {
    width: 100%;
  }
}

.loading {
  &-wrapper {
    width: 100%;
    height: 100%;
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.8);
    display: none;
    justify-content: center;
    align-items: center;
  }

  &-show {
    display: flex;
  }

  &-spinner {
    width: 150px;
    height: 150px;
    background-color: #f7f7f9;
    filter: alpha(opacity=50);
    -moz-opacity: 0.5;
    -khtml-opacity: 0.5;
    opacity: 0.5;
    background-image: url('../../assets/images/loading.gif');
    background-position: center center;
    background-repeat: no-repeat;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
